import { hexToRGBA2 } from "./Seleccionar/Converts";
export function colorRGB(_a, _b) {
    var r = _a[0], g = _a[1], b = _a[2];
    var _c = _b === void 0 ? [0, 0, 0] : _b, i = _c[0], j = _c[1], t = _c[2];
    return "rgb(".concat(r + i, ", ").concat(g + j, ", ").concat(b + t, ")");
}
export function textRGB(_a) {
    var r = _a[0], g = _a[1], b = _a[2];
    var r1 = r >= 128 ? 0 : 255;
    var g1 = g >= 128 ? 0 : 255;
    var b1 = b >= 128 ? 0 : 255;
    var max = Math.max(r1, g1, b1);
    var min = Math.min(r1, g1, b1);
    if (max !== min) {
        if (r1 === g1)
            b1 = b1 === min ? Math.max(r, g, b) : Math.min(r, g, b);
        if (r1 === b1)
            g1 = g1 === min ? Math.max(r, g, b) : Math.min(r, g, b);
        if (b1 === g1)
            r1 = r1 === min ? Math.max(r, g, b) : Math.min(r, g, b);
    }
    return colorRGB([r1, g1, b1]);
}
export default function getColor(hex, hover, invert) {
    if (hex.includes('gradient')) {
        return {
            color: '#FFFFFF',
            background: hex
        };
    }
    var rgb = hexToRGBA2(hex);
    if (hover) {
        var backH = colorRGB(rgb, [-20, -20, -20]);
        var textH = textRGB(rgb.map(function (c) { return 255 - c; }));
        return {
            color: invert ? textH : backH,
            borderColor: invert ? textH : backH,
            backgroundColor: invert ? backH : textH
        };
    }
    var back = colorRGB(rgb);
    var text = textRGB(rgb);
    return {
        color: invert ? text : back,
        borderColor: invert ? text : back,
        backgroundColor: invert ? back : text
    };
}
//# sourceMappingURL=getColors.js.map